const SESSION_KEY_PREFIX = 'chatbot';

function buildKey(advocateId: string, programId: string): string {
  return `${SESSION_KEY_PREFIX}_${advocateId}_${programId}`;
}

export function saveChatThreadId(
  advocateId: string,
  programId: string,
  threadId: string
): void {
  try {
    sessionStorage.setItem(buildKey(advocateId, programId), threadId);
  } catch {
    // sessionStorage may be unavailable (e.g. private browsing quota exceeded)
  }
}

export function getChatThreadId(
  advocateId: string,
  programId: string
): string | undefined {
  try {
    return sessionStorage.getItem(buildKey(advocateId, programId)) ?? undefined;
  } catch {
    return undefined;
  }
}

export function clearChatThreadId(advocateId: string, programId: string): void {
  try {
    sessionStorage.removeItem(buildKey(advocateId, programId));
  } catch {
    // sessionStorage may be unavailable
  }
}
